module.exports = __webpack_public_path__ + "static/media/geniusLogo.82012e24.svg";